import React from "react";
import SalaryEarningListData from "./SalaryEarningListData";

const SalaryTemplateEarningList = ({ payrollPolicyList }) => {
 

  return (
    <div className="relative overflow-x-auto">
      <table className="w-full text-sm text-left text-gray-500 dark:text-gray-500">
        <thead className="text-xs font-medium uppercase bg-gray-50 dark:bg-gray-50 text-gray-600 border-b border-t dark:border-gray-200 tracking-wider">
          <tr>
            <th scope="col" className="px-10 py-3">
              NAME
              <i className="ico-down text-blue-600 cursor-pointer pl-2"></i>
            </th>
            <th scope="col" className="px-10 py-3">
              Descriptions
              <i className="ico-down text-blue-600 cursor-pointer pl-2"></i>
            </th>
            <th scope="col" className="px-10 py-3">
              IS ACTIVE
              <i className="ico-down text-blue-600 cursor-pointer pl-2"></i>
            </th>
            <th scope="col" className="px-10 py-3 text-right">
              <i className="ico-grid text-blue-600 cursor-pointer pl-2"></i>
            </th>
          </tr>
        </thead>
        <tbody>
          {payrollPolicyList.map((val, key) => (
            <SalaryEarningListData key={key} payrollPolicyList={val} />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SalaryTemplateEarningList;
